import { useEffect, useRef, useState } from "react";
import { SOCIALS } from "@/components/Layout";

export const SimTag = ({ children = "Simulated Data" }) => (
  <span className="sim-tag" data-testid="sim-tag">{children}</span>
);

export const SectionHead = ({ eyebrow, title, sub, align = "center" }) => (
  <div className={`max-w-2xl mb-16 ${align === "center" ? "text-center mx-auto" : ""}`}>
    {eyebrow && <span className="mono-font text-xs uppercase tracking-widest text-[#9945FF] font-semibold">{eyebrow}</span>}
    <h2 className="display-font uppercase text-3xl md:text-5xl text-white mt-2">{title}</h2>
    {sub && <p className="text-sm text-[#a8a1c2] mt-3">{sub}</p>}
  </div>
);

export const timeAgo = (iso) => {
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.max(1, Math.floor(diff / 60000));
  if (mins < 60) return `${mins} min${mins > 1 ? "s" : ""} ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs} hr${hrs > 1 ? "s" : ""} ago`;
  return `${Math.floor(hrs / 24)}d ago`;
};

export const CommunitySection = () => (
  <section id="community" className="py-24 px-6 bg-gradient-to-b from-[#090612] to-[#07050d] text-center">
    <div className="max-w-3xl mx-auto glass-panel p-10 md:p-16 rounded-3xl border border-[#14F195]/30 shadow-[0_0_50px_rgba(153,69,255,0.15)]">
      <span className="mono-font text-xs uppercase tracking-widest text-[#14F195] font-semibold">Join The Solana Pre-Launch</span>
      <h2 className="display-font uppercase text-4xl md:text-6xl text-white mt-3 mb-6">Build The Basket Together.</h2>
      <p className="text-base text-[#b5aed0] max-w-xl mx-auto mb-8 leading-relaxed">
        Help shape the future of the Solana basket ecosystem.
      </p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
        <a data-testid="community-x-btn" href={SOCIALS.x} target="_blank" rel="noopener noreferrer"
          className="w-full sm:w-auto px-8 py-4 rounded-xl bg-white text-black font-bold text-sm tracking-wider uppercase hover:bg-[#14F195] transition-colors">
          Follow On X (Twitter)
        </a>
        <a data-testid="community-telegram-btn" href={SOCIALS.telegram} target="_blank" rel="noopener noreferrer"
          className="w-full sm:w-auto px-8 py-4 rounded-xl bg-[#9945FF] text-white font-bold text-sm tracking-wider uppercase hover:bg-[#8025e6] transition-colors">
          Join Telegram Community
        </a>
      </div>
    </div>
  </section>
);

/** Animated count-up number. */
export const CountUp = ({ value, prefix = "", suffix = "", decimals = 0, duration = 1600 }) => {
  const [display, setDisplay] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    let raf;
    const start = performance.now();
    const tick = (t) => {
      const p = Math.min(1, (t - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(value * eased);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [value, duration]);
  return (
    <span ref={ref}>
      {prefix}{display.toLocaleString("en-US", { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}{suffix}
    </span>
  );
};
